module.exports = __webpack_public_path__ + "img/SY-FFT-G.cbd8edfc.jpg";